import { IsNotEmpty, IsInt, IsString, MaxLength, IsOptional, IsISO8601, IsBoolean, IsArray, MinLength } from 'class-validator';
import { CalendarEventEditParticipantsDTO } from './calendar-event-edit-participants.dto';

export class CalendarEventEditDTO {

    @IsNotEmpty()
    @IsInt()
    type: number;

    @IsNotEmpty()
    @IsString()
    @MaxLength(255)
    title: string;

    @IsOptional()
    @IsString()
    description: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    location: string;

    @IsOptional()
    @IsISO8601()
    start: string;

    @IsOptional()
    @IsISO8601()
    end: string;

    @IsOptional()
    @IsString()
    recurrence: string;

    @IsOptional()
    @IsInt()
    duration: number;

    @IsNotEmpty()
    @IsBoolean()
    publicHoliday: boolean;

    @IsNotEmpty()
    @IsInt()
    allowance: number;

    @IsNotEmpty()
    @IsBoolean()
    pending: boolean;

    @IsOptional()
    @IsArray()
    @IsISO8601({
        each: true
    })
    excludedDates: Array<string>;

    @IsOptional()
    @IsArray()
    participants: Array<CalendarEventEditParticipantsDTO>;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    resources: Array<string>;

}
